import { render, staticRenderFns } from "./AggiungiModificaTipoScarico.vue?vue&type=template&id=a7445a92&"
import script from "./AggiungiModificaTipoScarico.vue?vue&type=script&lang=js&"
export * from "./AggiungiModificaTipoScarico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports